import {MutationTree} from "vuex";
import { Mutations, ResetStepValues, State } from '@/store/user/types';
import {ServiceNumbers} from "@/types";
import { sortServiceNumbers, sortServiceNumbersTypes } from '@/utils/main';

const mutations: MutationTree<State> & Mutations = {
    setToken(state, payload) {
        state.token = payload
    },
    setError(state, payload) {
        state.error = payload
    },
    setUser(state, payload) {
        state.user_info = payload

        const { serviceNumbers } = payload;

        const filteredServiceNumbers = serviceNumbers.filter((item: ServiceNumbers) => sortServiceNumbersTypes.includes(item.typeEmployment));

        if (filteredServiceNumbers.length > 0) {
            const sortedServiceNumbers = sortServiceNumbers(filteredServiceNumbers);
            state.user_position = sortedServiceNumbers[0].position;
            state.user_position_bid = sortedServiceNumbers[0].bid;
        }
    },
    setLoader(state, payload) {
        state.loader = payload
    },
    setPasswordResetStep(state, payload: ResetStepValues) {
        state.reset_step = payload
    },
    clearPasswordResetSteps(state) {
        state.reset_step = ResetStepValues.Step1
        sessionStorage.removeItem('resetSessionUID')
        sessionStorage.removeItem('resetCodeSessionUID')
        sessionStorage.removeItem('resetPassSessionUID')
    }
};

export default mutations